import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ConfirmStatusChangeItemModel } from './confirm-status-change-item.model';
import { ConfirmStatusChangeResponseModel } from './confirm-status-change-response.model';


@Component({
  moduleId: module.id,
  selector: 'confirm-status-changes',
  templateUrl: 'confirm-status-changes.component.html',
  styleUrls: ['confirm-status-changes.component.scss'],
})
export class ConfirmStatusChangesComponent {
  @Input() title: string = 'Confirm Status Changes';
  @Input() statuses: Array<ConfirmStatusChangeItemModel> = [];
  @Input() data: any;
  @Input() note: string;

  @Output() action: EventEmitter<ConfirmStatusChangeResponseModel> = new EventEmitter<ConfirmStatusChangeResponseModel>();

  onConfirmClick() {
    const modalResponse = new ConfirmStatusChangeResponseModel();
    modalResponse.action = 'confirmed';
    modalResponse.data = this.data;
    this.action.emit(modalResponse);
  }

  onCancelClick() {
    const modalResponse = new ConfirmStatusChangeResponseModel();
    modalResponse.action = 'canceled';
    modalResponse.data = this.data;
    this.action.emit(modalResponse);
  }

  getColor(status: string): string {
    switch (status) {
      case 'Review':
        return 'gold';
      case 'Approved':
        return 'green';
      case 'Draft':
        return 'red';
      case 'Draft':
        return 'red';
      case 'Unchanged':
        return 'black';
      default:
        return 'black';
    }
  }

}
